import { useMsal } from "@azure/msal-react";
import Button from "@mui/material/Button";
import { loginRequest } from "../authConfig";

export const BAVLogout = () => {
  const { instance } = useMsal();


  const handleLogout = async () => {
      // 1. App-State löschen
      localStorage.clear();
      sessionStorage.clear();

      // 2. MSAL sauber abmelden
      await instance.logoutRedirect({
          postLogoutRedirectUri: window.location.origin,
      });
  };

  return (
    <div>
      <Button onClick={(event) => handleLogout()} color="inherit">
        Logout
      </Button>
    </div>
  );
};
